<style lang="scss" scoped>
.slideshow-item-info {
  text-align: left;
  // padding: 10px 0;
  padding: 15px;
}
.swiper-container {
  background-color: #000;
  z-index: 0;
}
.swiper-wrapper {
  z-index: 0;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  background-color: #fff;
  & > img {
    vertical-align: middle;
    object-fit: cover;
    padding-bottom: 35px;
  }
}
.swiper-button-prev {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ5Mi4wMDQgNDkyLjAwNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDkyLjAwNCA0OTIuMDA0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIGNsYXNzPSIiPjxnIHRyYW5zZm9ybT0ibWF0cml4KC0wLjgwMTQ3IDAgMCAwLjgwMTQ3IDQ0My4xNjUgNDguODM4NykiPjxnPgoJPGc+CgkJPHBhdGggZD0iTTM4Mi42NzgsMjI2LjgwNEwxNjMuNzMsNy44NkMxNTguNjY2LDIuNzkyLDE1MS45MDYsMCwxNDQuNjk4LDBzLTEzLjk2OCwyLjc5Mi0xOS4wMzIsNy44NmwtMTYuMTI0LDE2LjEyICAgIGMtMTAuNDkyLDEwLjUwNC0xMC40OTIsMjcuNTc2LDAsMzguMDY0TDI5My4zOTgsMjQ1LjlsLTE4NC4wNiwxODQuMDZjLTUuMDY0LDUuMDY4LTcuODYsMTEuODI0LTcuODYsMTkuMDI4ICAgIGMwLDcuMjEyLDIuNzk2LDEzLjk2OCw3Ljg2LDE5LjA0bDE2LjEyNCwxNi4xMTZjNS4wNjgsNS4wNjgsMTEuODI0LDcuODYsMTkuMDMyLDcuODZzMTMuOTY4LTIuNzkyLDE5LjAzMi03Ljg2TDM4Mi42NzgsMjY1ICAgIGM1LjA3Ni01LjA4NCw3Ljg2NC0xMS44NzIsNy44NDgtMTkuMDg4QzM5MC41NDIsMjM4LjY2OCwzODcuNzU0LDIzMS44ODQsMzgyLjY3OCwyMjYuODA0eiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBzdHlsZT0iZmlsbDojRkZGRkZGIiBkYXRhLW9sZF9jb2xvcj0iI2ZmZmZmZiI+PC9wYXRoPgoJPC9nPgo8L2c+PC9nPiA8L3N2Zz4=);
  background-color: rgba(0, 0, 0, 0.3);
  &:focus {
    background-color: rgba(0, 0, 0, 0.5);
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
}
.swiper-button-next {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ5Mi4wMDQgNDkyLjAwNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDkyLjAwNCA0OTIuMDA0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIGNsYXNzPSIiPjxnIHRyYW5zZm9ybT0ibWF0cml4KDAuODAxMzEgMCAwIDAuODAxMzEgNDguODc4MSA0OC44NzgxKSI+PGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMzgyLjY3OCwyMjYuODA0TDE2My43Myw3Ljg2QzE1OC42NjYsMi43OTIsMTUxLjkwNiwwLDE0NC42OTgsMHMtMTMuOTY4LDIuNzkyLTE5LjAzMiw3Ljg2bC0xNi4xMjQsMTYuMTIgICAgYy0xMC40OTIsMTAuNTA0LTEwLjQ5MiwyNy41NzYsMCwzOC4wNjRMMjkzLjM5OCwyNDUuOWwtMTg0LjA2LDE4NC4wNmMtNS4wNjQsNS4wNjgtNy44NiwxMS44MjQtNy44NiwxOS4wMjggICAgYzAsNy4yMTIsMi43OTYsMTMuOTY4LDcuODYsMTkuMDRsMTYuMTI0LDE2LjExNmM1LjA2OCw1LjA2OCwxMS44MjQsNy44NiwxOS4wMzIsNy44NnMxMy45NjgtMi43OTIsMTkuMDMyLTcuODZMMzgyLjY3OCwyNjUgICAgYzUuMDc2LTUuMDg0LDcuODY0LTExLjg3Miw3Ljg0OC0xOS4wODhDMzkwLjU0MiwyMzguNjY4LDM4Ny43NTQsMjMxLjg4NCwzODIuNjc4LDIyNi44MDR6IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIHN0eWxlPSJmaWxsOiNGRkZGRkYiIGRhdGEtb2xkX2NvbG9yPSIjZmZmZmZmIj48L3BhdGg+Cgk8L2c+CjwvZz48L2c+IDwvc3ZnPg==);
  background-color: rgba(0, 0, 0, 0.3);
  &:focus {
    background-color: rgba(0, 0, 0, 0.5);
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
}
.gallery-thumbs {
  background-color: #000;
  height: auto;
  box-sizing: border-box;
  padding: 15px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
@media (min-width: 1281px) {
  .main-slideshow-img {
    height: 350px;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .main-slideshow-img {
    height: 350px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .main-slideshow-img {
    height: 350px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .main-slideshow-img {
    height: 350px;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .main-slideshow-img {
    height: 300px;
  }
}
@media (min-width: 320px) and (max-width: 480px) {
  .main-slideshow-img {
    height: 300px;
  }
}
</style>
<style>
.slideshow-component .swiper-pagination-bullet {
  opacity: 0.4;
  background: #000;
}
.slideshow-component .swiper-pagination-bullet-active {
  opacity: 1;
  background: var(--primary-color);
}
</style>

<template>
  <div class="slideshow-component">
    <div style="position:relative">
      <!-- NOTE: main slider -->
      <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop"
        @slideChangeTransitionEnd="getCurrentSlideIndex()">
        <swiperSlide v-for="(item,itemIdx) in newSlideshowItemList" v-if="item.photo" :key="itemIdx">
          <img @click="showVuerPlaylist($event,'imgViewer',false,itemIdx)" alt=" " id="myImg" class="main-slideshow-img" :src="slideshowPhoto(item)" width="100%"/>
          <img v-show="false" ref="imgViewer" :src="slideshowPhoto(item)" width="100%" alt="IMAGE">
        </swiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-button-prev" slot="button-prev"></div> -->
      </swiper>
      <!-- NOTE: thumbs -->
      <!-- <swiper v-show="false" :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
        <swiperSlide v-for="(item,thumbIdx) in newSlideshowItemList" :key="thumbIdx">
          <img :src="item.photo.medium" height="60px" width="90%"/>
        </swiperSlide>
      </swiper> -->
      <Spin size="large" fix v-if="showLoading"></Spin>
    </div>
    <div v-if="currentItem" class="slideshow-item-info">
      <h4 style="text-transform:capitalize">{{title}}</h4>
      <p v-html="description"></p>
    </div>

  </div>
</template>

<script>
import Utils from '@/utils.js'
import VuerMixin from '@/helpers/vuerMixin'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'SlideshowComponent',
  props: {
    slideshowItem: {
      type: Object,
      required: true
    },
    coverPhoto: {
      type: String,
      required: false
    },
    slideshowDescription: {
      type: String
    }
  },
  data() {
    return {
      photo: { small: '', medium: '' },
      currentItem: null,
      swiperOptionTop: {
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        effect: 'fade'
      },
      // swiperOptionThumbs: {
      //   spaceBetween: 10,
      //   centeredSlides: true,
      //   slidesPerView: 'auto',
      //   touchRatio: 0.2,
      //   slideToClickedSlide: true
      // },
      showLoading: false
    }
  },
  mixins: [VuerMixin],
  methods: {
    isImgLoaded() {
      var image = document.getElementById("myImg");
      this.showLoading = true;
      return new Promise(res => {
        image.onload = res
      }).then(() => {
        this.showLoading = false;
      })
    },
    getCurrentSlideIndex() {
      let index = this.$refs.swiperTop.swiper.activeIndex;
      this.currentItem = this.newSlideshowItemList[index];
    },
    addCoverPhotoToList() {
      this.photo.small = this.coverPhoto;
      this.photo.medium = this.coverPhoto;
      this.currentItem = this.newSlideshowItemList[0]
    },
    slideshowPhoto(item) {
      return Utils.getDisplayImage('slideshow', item, 'medium')
    }
  },
  computed: {
    title: {
      get() { return this.currentItem.title }
    },
    description: {
      get() { return this.slideshowDescription }
    },
    newSlideshowItemList: {
      get() { 
        return this.slideshowItem.list
      }
    }
  },
  watch: {
    currentItem: function(n, o) {
      console.log('current item', n)
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted() {
    this.addCoverPhotoToList();
    // this.$nextTick(() => {
    //   const swiperTop = this.$refs.swiperTop.swiper
    //   const swiperThumbs = this.$refs.swiperThumbs.swiper
    //   swiperTop.controller.control = swiperThumbs
    //   swiperThumbs.controller.control = swiperTop
    // })
    // this.isImgLoaded();
  }
};
</script>
